import { createApiClient } from "./apiClient";

export class RoleService {
  constructor(authAPIUrl) {
    this.apiClient = createApiClient(authAPIUrl, "v1/roles");
  }

  async getRoles() {
    return this.apiClient.get();
  }
}
